<section class="p-2 p-md-4">
  <div class="card mb-4">
    <div class="table-responsive">
      <div class="card-header bg-white">
        <div class="d-flex mb-3">
          <div>
            <div class="text-truncate">ID</div>
            <div class="form-control disabled bg-light border-grey">{{ idConsulta }}</div>
          </div>
          <div class="w-100 ml-3">
            <div class="text-truncate">Tipo</div>
            <div class="form-control disabled bg-light border-grey">{{ nomeTipoConsulta | uppercase }}</div>
          </div>
        </div>
      </div>
      <div class="card-body row">
        <div class="w-100 p-2 m-10">
          <h3>Adicionar nova saída</h3>
        </div>
        <div class="col-12 col-lg-6 p-2">
          <label for="nome">Nome</label>
          <input type="text" autocomplete="false" class="form-control input-validate" name="nome" id="nome" [formControl]="form.controls.nome">
          <app-msg-erro [control]="form.controls.nome"></app-msg-erro>
        </div>
        <div class="col-12 col-lg-6 p-2">
          <label for="descricao">Descrição</label>
          <input type="text" autocomplete="false" class="form-control input-validate" name="descricao" id="descricao" [formControl]="form.controls.descricao">
          <app-msg-erro [control]="form.controls.descricao"></app-msg-erro>
        </div>
        <div class="col-12 col-lg-6 p-2">
          <label for="caminho">Caminho</label>
          <input type="text" autocomplete="false" class="form-control input-validate" name="caminho" id="caminho" [formControl]="form.controls.caminho">
          <app-msg-erro [control]="form.controls.caminho"></app-msg-erro>
        </div>
        <div class="col-12 col-lg-6 p-2">
          <label for="tipoCampo">Tipo do campo</label>
          <select class="form-control input-validate" [formControl]="form.controls.tipo" name="tipoCampo" id="tipoCampo">
            <option value="">Selecione</option>
            <option *ngFor="let c of listaTipoCampo" [value]="c.id">{{c.nometipocampoconsulta | uppercase}}</option>
          </select>
          <app-msg-erro [control]="form.controls.tipo"></app-msg-erro>
        </div>
        <div class="col-12 col-lg-6 p-2">
          <label for="dadosConsultaSaidaPai">Consulta saída Pai</label>
          <select class="form-control input-validate" [formControl]="form.controls.dadosConsultaSaidaPai" name="dadosConsultaSaidaPai" id="dadosConsultaSaidaPai">
            <option value="">Selecione</option>
            <option *ngFor="let c of listaDCSPai" [value]="c.id">{{c.nome | uppercase}}</option>
          </select>
          <app-msg-erro [control]="form.controls.dadosConsultaSaidaPai"></app-msg-erro>
        </div>
        <div *ngFor="let c of visibilidade" class="col-12 col-lg-6 p-2 default-mg my-4">
          <app-checkbox class="md" [(checked)]="checkedForm" [label]="c.nome" [disabled]="disabledConsultas" (checkedChange)="checkedVisibilidade($event)"></app-checkbox>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end card-footer bg-white text-muted">
      <button [disabled]="form.invalid" class="btn btn-md px-5 btn-success" (click)="submitForm()">
        <span>Salvar</span>
      </button>
    </div>
  </div>
</section>

<section class="p-2 p-md-4">
  <app-historico-dcs [idConsulta]="id" [loading]="loading"></app-historico-dcs>
</section>